module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Arm Sofa.647dd84a.jpg";